import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { FeedbackSettings } from '@mp/shared/helper-links/feedback/domain';

import { FeedbackActions } from './feedback.actions';
import { selectFeedbackSettings, selectIsLoading } from './feedback.selectors';

@Injectable()
export class FeedbackFacade {
  private readonly store$ = inject(Store);
  private readonly actions$ = inject(Actions);

  readonly feedbackSettings$: Observable<FeedbackSettings | undefined> = this.store$.select(selectFeedbackSettings);

  readonly isLoading$: Observable<boolean> = this.store$.select(selectIsLoading);

  readonly updateFeedbackSettingsSuccess$: Observable<unknown> = this.actions$.pipe(
    ofType(FeedbackActions.updateFeedbackSettingsSuccess),
  );

  fetchFeedbackSettings(): void {
    this.store$.dispatch(FeedbackActions.fetchFeedbackSettings());
  }

  updateFeedbackSettings(feedbackSettings: FeedbackSettings): void {
    this.store$.dispatch(FeedbackActions.updateFeedbackSettings({ feedbackSettings }));
  }
}
